import { render } from "./indexProposalComponent.vue?vue&type=template&id=7f21f50b&scoped=true"
import script from "./indexProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexProposalComponent.vue?vue&type=script&lang=js"

import "./indexProposalComponent.vue?vue&type=style&index=0&id=7f21f50b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f21f50b"]])

export default __exports__